/**
 * Visible-label wrapper used by every form in the app.
 * - label always visible above the field so a filled-in value is identifiable
 * - required={true} appends a red asterisk
 * - hint shows a tiny helper line underneath (e.g. "ex GST", DD/MM/YYYY)
 * - renderChildren takes an input/select/textarea with its own data-testid
 */
export default function Field({ label, required, hint, children, testid, className = "" }) {
  return (
    <label className={`block text-sm ${className}`} data-testid={testid}>
      <span className="block text-xs text-silver mb-1">
        {label}{required && <span className="text-red-400 ml-0.5">*</span>}
      </span>
      {children}
      {hint && <span className="block text-[11px] opacity-60 mt-0.5">{hint}</span>}
    </label>
  );
}
